var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIwActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 85,
    viewBox: "0 0 97 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    clipPath: "url(#clip0_7201_48633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2916 85H0V25.4476L48.1458 0L96.2916 25.4476V85ZM7.54476 77.4552H88.734V30L48.1458 8.5422L7.54476 30V77.4552Z",
    fill: "#6AD67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1528 40.9079V51.5984L48.1477 69.6035L30.1426 51.5984V40.9079L44.3753 55.1534V23.9769H51.9201V55.1534L66.1528 40.9079Z",
    fill: "#6AD67D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7201_48633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.2916,
    height: 85,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIwActive);
export default __webpack_public_path__ + "static/media/iw-active.87a1e5df5d130bf27bbed975e01e333d.svg";
export { ForwardRef as ReactComponent };